import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M17.6565 9.58539L10.5865 16.6564L6.34351 12.4134L7.75751 10.9994L10.5865 13.8284L16.2425 8.17139L17.6565 9.58539Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }